import * as Logger from '../libs/wa-logger';
import * as Helper from "./main-menu-helper"
import * as Guards from "../libs/guards"

const $ = require('jquery');
// function largeMainMenuDropdownItems(enable: boolean) {
// 	const dropdown_menu_items = document.querySelectorAll('.dropdown')

// 	function handleExpand(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		t.classList.add('open')
// 		console.log(["entered", ev])
// 	}
// 	function handleCollapse(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		t.classList.remove('open')
// 		console.log(["leaving", ev])
// 	}
// 	if(enable) {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.addEventListener("mouseenter", handleExpand)
// 			li_el.addEventListener("mouseleave", handleCollapse)
// 		})
// 	} else {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.removeEventListener("mouseenter", handleExpand)
// 			li_el.removeEventListener("mouseleave", handleCollapse)
// 		})
// 	}
// }
// function smallMainMenuDropdownItems(enable: boolean) {
// 	const dropdown_menu_items = document.querySelectorAll('.dropdown')

// 	function handleExpand(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		if(! t.classList.contains('open')) {
// 			t.classList.add('open')
// 			console.log(["entered", ev])
// 		}
// 	}
// 	function handleCollapse(ev: Event) {
// 		const t = ev.currentTarget as HTMLLIElement
// 		if(t.classList.contains('open')){
// 			t.classList.remove('open')
// 			console.log(["leaving", ev])
// 		}
// 	}
// 	if(enable) {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.addEventListener("mouseenter", handleExpand)
// 			li_el.addEventListener("mouseleave", handleCollapse)
// 		})
// 	} else {
// 		dropdown_menu_items.forEach((el) => {
// 			const li_el = Guards.isHTMLLIElement(el)
// 			li_el.removeEventListener("mouseenter", handleExpand)
// 			li_el.removeEventListener("mouseleave", handleCollapse)
// 		})
// 	}
// }

export function initialize() {
	Logger.log(['main-menu', Helper.setupMainMenu]);
	const a1 = $('#navbar a');
	if (a1.length === 0) {
		Logger.log('mainMenu - selector not found');
		return;
	}
	const select_non_dropdown_items = '#navbar > li:not(.dropdown) > a:not(.dropdown-toggle)';
	const select_dropdown_button = '#navbar > li.dropdown > a.dropdown-toggle';
	const select_dropdown_items = '#navbar > li.dropdown > ul > li:not(.divider)'
	const select_dropdown_anchors = '#navbar > li.dropdown > ul > li:not(.divider) > a';

	// const non_dropdown_items = $(select_non_dropdown_items);
	// const dropdown_button = $(select_dropdown_button);
	// const dropdown_items = $(select_dropdown_items);
	// const dropdown_anchors = $(select_dropdown_anchors);
	const non_dropdown_items = document.querySelectorAll(select_non_dropdown_items);
	const dropdown_button = document.querySelectorAll(select_dropdown_button);
	const dropdown_items = document.querySelectorAll(select_dropdown_items);
	const dropdown_anchors = document.querySelectorAll(select_dropdown_anchors);

	/** Setup a tooltip for all the main menu items that are NOT dropdown menus */
	Helper.setupMainMenu(select_non_dropdown_items, 'sw')
	// menuToolTip(select_dropdown_items, 'e')

	// $(dropdown_items).click((event: any) => {
	// 	const text = $(event.target).text();
	// 	$(dropdown_button).text(text);
	// 	console.log([event, $(event.target).text()]);
	// });
	// $(dropdown_anchors).click((event: any) => {
	// 	const text = $(event.target).text();
	// 	$(dropdown_button).text(text);
	// 	console.log([event, $(event.target).text()]);
	// });

	/** Setup all main menu dropdown menu items to expand on mouse over */
	// const dropdown_menu_items = document.querySelectorAll('.dropdown')
	// function handleMouseEnter(ev: Event) {
	// 	const t = ev.currentTarget as HTMLLIElement
	// 	t.classList.add('open')
	// 	console.log(["entered", ev])
	// }
	// function handleMouseLeave(ev: Event) {
	// 	const t = ev.currentTarget as HTMLLIElement
	// 	t.classList.remove('open')
	// 	console.log(["leaving", ev])
	// }
	// dropdown_menu_items.forEach((el) => {
	// 	const li_el = Guards.isHTMLLIElement(el)
	// 	li_el.addEventListener("mouseenter", handleMouseEnter)
	// 	li_el.addEventListener("mouseleave", handleMouseLeave)
	// })
};
function setupMediaQueries(){
	const mq480 = window.matchMedia("(width <= 480px)")
	mq480.addEventListener("change", (a: any) => {
		console.log(["mq480", a.matches])
	})
	const mq922 = window.matchMedia("(width <= 922px)")
	mq922.addEventListener("change", (a: any) => {
		console.log(["mq922", a.matches])
	})
	const mq1200 = window.matchMedia("(width <= 1200px)")
	mq1200.addEventListener("change", (a: any) => {
		console.log(["mq1200", a.matches])
	})
	const mq1800 = window.matchMedia("(width <= 1800px)")
	mq1200.addEventListener("change", (a: any) => {
		console.log(["mq1800", a.matches])
	})

}